/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Classification_TitleInputs */

const vi_product_classification_title = /** @type {(inputs: Product_Classification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phân loại sản phẩm`)
};

/**

* @param {Product_Classification_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_classification_title = /** @type {((inputs?: Product_Classification_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Classification_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_classification_title(inputs)
});